module.exports = __webpack_public_path__ + "img/bt.6c90ad0a.svg";